import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/router'
import store from '@/store'
import '@/directives/title.directive'
// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
// import VConsole from 'vconsole'
// let vconsole = new VConsole()
Vue.prototype.$scrollTo = (x = 0, y = 0, type = 'smooth') => {
  window.scrollTo({
    top: x,
    left: y,
  })
}
// vant 库
import {
  Tabbar,
  TabbarItem,
  DatetimePicker,
  Popup,
  Checkbox,
  CheckboxGroup,
  Toast,
  Icon,
  Picker,
  Field,
  IndexBar,
  IndexAnchor,
  Collapse,
  CollapseItem,
  Cell,
  CellGroup,
  PullRefresh,
  List,
  Overlay,
  Dialog,
  Radio,
  Loading,
  Image,
  Cascader,
  Button,
  Divider,
  Calendar,
  Search,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
} from 'vant'
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(Picker)
Vue.use(Field)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Overlay)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(Loading)
Vue.use(Image)
Vue.use(Cascader)
Vue.use(Button)
Vue.use(Divider)
Vue.use(Calendar)
Vue.use(Search)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(RadioGroup)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
